import {AfterViewInit, Component, NgZone, OnInit} from '@angular/core';
import {BookingService} from "./booking.service";
import {Page} from "../../shared/pager/page";
import {ActivatedRoute} from "@angular/router";
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import {GAService} from "../../root/ga/ga.service";
import {TranslateService} from "@ngx-translate/core";
import {PointOfSaleA2Service} from "../../core/point-of-sale.service.service";
import {DateService} from "../../core/date.service";
import {CompanyServiceA2} from "../../core/company_a2.service";
import {GeoServiceA2} from "../../core/geo_a2.service";
import {SidebarService} from "../../root/sidebar/sidebar.service";
import {CookieOptions, CookieService} from "ngx-cookie";
import * as _ from "lodash";
import {MobileService} from "../../core/mobile.service";
import {NotificationService} from "../../root/toast/notification.service";
import {SessionService} from "../../core/session.service";

@Component({
    selector: 'booking',
    templateUrl: './booking.component.html',
    providers:[BookingService, PointOfSaleA2Service, DateService, MobileService]
})
export class BookingComponent implements OnInit, AfterViewInit {
    callbackExport: Function = () => {this.exportData()};
    metadata:any = {'status':[], 'dateType':[], 'paymentMethod':[], 'placeOfPurchase':[], 'pointsOfSale': []};
    filterApplied:any;
    private companyOid:number;
    spage:any = new Page();
    hasBookings:boolean = false;
    emptyStateBooking = false;
    noBookingDays:string = "";
    currentDate;
    tomorrow;
    defaultFilters:any;
    totalCount:any = {"TODAY": "", "TOMORROW": "", "ALL": "", "FILTERED": ""};
    hideFiltered:boolean = false;
    paginator;
    test: boolean = false;
    landing: any = {};
    tour;
    modalClosable: boolean = true;
    allList;
    selectedNavIndex: number = 0;
    cmpReady: boolean = false;
    private options: CookieOptions = {
        expires: new Date("2117")
    };
    openedFilters:boolean = false;
    showMarkRead:boolean = false;
    dspFilters;
    constructor(private bookingService:BookingService, private route: ActivatedRoute,
                private loading: LoadingWheelService, private zone:NgZone, private ga:GAService,
                private translator:TranslateService, private posService:PointOfSaleA2Service,
                private dateService:DateService, private sidebarService:SidebarService,
                private companyService: CompanyServiceA2, private geoService: GeoServiceA2,
                private _cookieService:CookieService, private mobileService: MobileService,
                private toast:NotificationService, private session: SessionService) {
	this.sidebarService.sidebar = "bookings";
    }

    subNavs;
    ngAfterViewInit() {
        this.paginator = <HTMLElement>document.querySelector(".pagination-item.eva-3-link.-active");
        this.subNavs = document.querySelector("dsp-sub-navs");
        this.dspFilters = document.querySelector("dsp-filters-horizontal");
        this.tour = document.querySelector("dsp-modal-coachmark");

    }

    ngOnInit() {
        this.currentDate = new Date();
        // this.sidebar._sidebar = "bookings";

        this.tomorrow = new Date(this.currentDate);
        this.tomorrow.setDate(this.currentDate.getDate()+1);

        this.allList = new Date(this.currentDate);
        this.allList.setMonth(this.currentDate.getMonth() + 3);

        this.defaultFilters = [{
            'sSortDir_0':'asc',
            'dateType':'PICK_UP',
            'period.from': this.dateService.formatDateToYYYYMMDD(this.currentDate),
            'period.to': this.dateService.formatDateToYYYYMMDD(this.currentDate),
            'filterId':'TODAY',
            'index': 0,
            'sortingColumnName': 'PICKUP_DATE'
        }, {
            'sSortDir_0':'asc',
            'dateType':'PICK_UP',
            'period.from': this.dateService.formatDateToYYYYMMDD(this.tomorrow),
            'period.to': this.dateService.formatDateToYYYYMMDD(this.tomorrow),
            'filterId':'TOMORROW',
            'index': 1,
            'sortingColumnName': 'PICKUP_DATE'
        }, {
            'sSortDir_0':'asc',
            'dateType':'PICK_UP',
            'period.from': this.dateService.formatDateToYYYYMMDD(this.currentDate),
            'period.to': this.dateService.formatDateToYYYYMMDD(this.allList),
            'filterId':'ALL',
            'index': 2,
            'sortingColumnName': 'PICKUP_DATE'
        }];
        this.loading.show();
        this.route.params.subscribe(params => {
            this.companyOid = params['companyId'];
            //TODO fix with service getWithParams
            if(!!this.companyOid){
                this.getPointsOfSale(this.companyOid);
            }else{
                this.metadata.posSelect = true;
            }
        });
        let isLanding = false;
        let isDetail = false;
        let filter = {
            'sSortDir_0':'desc',
            'dateType':'PICK_UP',
            'period.from': '',
            'period.to': '',
            'filterId': 'TODAY',
            'sortingColumnName': 'PICKUP_DATE',
            'index': 0
        };

        this.route.queryParams.subscribe(params => {
            let landing = params['landing'];
            let detail = params['detail']
            if(landing){
                let dateFrom = params['from'];
                let dateTo = params['to'];
                isLanding = true;
                this.landing = {
                    valid: true,
                    from: dateFrom,
                    to: dateTo,
                    dateType: "PICK_UP"
                };
                filter['period.from'] = dateFrom;
                filter['period.to'] = dateTo;
                this.filterByDay(dateFrom, filter);
            }
            if(detail){
                filter['bookingOID'] = params["bookingOID"];
                filter.filterId = 'FILTERED';
                filter.index = 3;
                isDetail = true;
                this.selectedNavIndex = 2;
                this.hideFiltered = true;
                filter['period.from'] = '';
                filter['period.to'] = '';
                filter['dateType'] = '';
            }
        });


        this.bookingService.getData().subscribe(result => {
            this.metadata['status'] = result[0];
            this.metadata['dateType'] = result[1];
            this.metadata['paymentMethod'] = result[2];
            this.metadata['placeOfPurchase'] = result[3];
            if(!isLanding && !isDetail){
                filter['period.from'] = this.dateService.formatDateToYYYYMMDD(this.currentDate);
                filter['period.to'] = this.dateService.formatDateToYYYYMMDD(this.currentDate);
            }
            this.filterBookingList(filter, false, false, false);
        });


        this.metadata['companyNames'] = [];
        this.metadata['cities'] = [];


        this.showReadBookingToast();
    }

    showReadBookingToast(){
        if(!this.session.getUserSession()){
            this.session.getSubject().subscribe((message) => {
                if(!!message.done){
                    this.bindSessionParameters();
                }
            });
        }else{
            this.bindSessionParameters();
        }
    }

    private bindSessionParameters() {
        //Toast y cookie checkbox booking read
        if(this.session.getUserSession().userType == "COMPANY") {
            this.showMarkRead = true;
        }

    }
    filterByDay(dateFrom, filter){
        this.hideFiltered = false;
        if(dateFrom == this.dateService.formatDateToYYYYMMDD(this.currentDate)){
            filter.filterId = 'TODAY';
            filter.index = 0;
            this.selectedNavIndex = 0;
        }else if (dateFrom == this.dateService.formatDateToYYYYMMDD(this.tomorrow)){
            filter.filterId = 'TOMORROW';
            filter.index = 1;
            this.selectedNavIndex = 1;
        }else{
            filter.filterId = 'FILTERED';
            filter.index = 3;
            this.selectedNavIndex = 2;
            this.hideFiltered = true;
        }
        return filter;
    }

    modalGoNext(event){
        let step = event.detail;
        this.sendGa("Modal_Siguiente", step);
    }

    modalCompleted(event){
        this.modalClosable = true;
        this.sendGa("Modal_Listo", "Listo");
    }

    modalGoPrevious(event){
        let step = event.detail;
        this.sendGa("Modal_Anterior", step);
    }

    modalClose(event){
        let step = event.detail.step;
        let origin = event.detail.origin;
        if(step != null && origin == "close"){
            this.sendGa("Modal_Cerrar", step);
        }
    }

    getPointsOfSale(company){
        this.posService.get(company).subscribe(result => {
            this.metadata['pointsOfSale'] = result.map((item) => {return {oid: item.oid, name: item.name}});
        })
    }

    getCitiesByName(nameLike){
        let language = this.translator.currentLang;
        this.geoService.getAirportsAndCities(nameLike, language).subscribe(result => {
            this.metadata['cities'] = result;
        })
    }

    getAllCompanies(companyName){
        let language = this.translator.currentLang;
        this.companyService.searchByNameLike(companyName, language).subscribe(result => {
            this.metadata['companyNames'] = result.map((item) => {return {oid: item.oid, name: item.name}});
        })
    }

    showModalCoachmark(){
        this.sendGa("Modal_Tour", "Tour");
    }

    filteredResult: any;
    filtersTabs = ["Hoy", "Mañana", "Todas", "Resultado de búsqueda"];

    sendGa(action, arg){
        this.ga.notify("Autos_listado_de_reservas", action, [arg]);
    }

    navSelection(event){
        var index = event.detail.index;
        this.sendGa("Seleccionar_tab", this.filtersTabs[index]);
        if( index != 3){
            this.filterBookingList(this.defaultFilters[index], false, false, false);
        }else{
            if(!!this.filteredResult){
                this.filterBookingList(this.filteredResult, false, false, false);
            }
        }
        window.scrollTo(0, 0);
    }

    filterBookingList(filter:any, changePage:boolean=false, defaultValue:boolean, isApply:boolean){
        this.loading.show();
        this.filterApplied = filter;
        if(isApply){
            this.subNavs.selectNav(3);
        }
        this.zone.run(() => {
            if (!!this.companyOid) {
                this.bookingService.getByCompany(this.companyOid, filter, changePage?this.spage.currentPage:1).subscribe(result => {
                    this.resolveBookings(result, filter, changePage, defaultValue)
                });
            } else {
                this.loading.show();
                this.bookingService.get(filter, changePage?this.spage.currentPage:1).subscribe(result => {
                    this.loading.show();
                    this.resolveBookings(result, filter, changePage, defaultValue);
                });
            }
        });
    }

    private resolveBookings(result, filter, changePage, defaultValue){
        this.loading.show();
        this.spage = new Page(result.itemsPerPage,result.currentPage,result.totalItems,result.items);
        if(filter.filterId == "FILTERED"){
            this.filteredResult = filter;
        }
        if(result.totalItems == 0){
            this.hasBookings = false;
            if(filter.filterId != "FILTERED"){
                this.noBookingDays = 'bookingList.EMPTY_STATE.NO_BOOKING.'+ filter.filterId;
                this.emptyStateBooking = false;
            }else{
                this.emptyStateBooking = true;
            }
        }else{
            this.loading.show();
            this.hasBookings = true;
            this.spage = this.parseItemsData(this.spage);
            if(filter.filterId == "TODAY" || filter.filterId == "TOMORROW"){
                this.spage.items = _.orderBy(this.spage.items, ['pickupDate_parsed.hour', 'pickupDate_parsed.dateTime'], ['asc', 'asc']);
            }else{
                this.spage.items = _.orderBy(this.spage.items, ['pickupDate_parsed.dateTime', 'pickupDate_parsed.hour'], ['asc', 'asc']);
            }
            this.loading.hide();
        }
        if(!changePage){
            if(defaultValue && filter.filterId == "TODAY"){
                this.selectedNavIndex = 0;
                this.hideFiltered = false;
            }
            if(filter.filterId == "FILTERED"){
                this.selectedNavIndex = 3;
                this.hideFiltered = true;
            }
            this.totalCount = {"TODAY": "", "TOMORROW": "", "ALL": "", "FILTERED": ""};
            this.totalCount[filter.filterId] = '(' + result.totalItems + ')';
        }

        if(this.mobileService.isMobile() && this.openedFilters){
            this.openedFilters = false;
            this.dspFilters.hide();
        }
        this.loading.hide();
    }

    parseItemsData(page){
        let metadata = this.metadata;
        let currentDate = this.currentDate.setHours(0,0,0,0);
        let bookingColors = ["green", "red", "orange", "light-blue", "red"];
        let tomorrow = this.tomorrow.setHours(0,0,0,0);

        for (var i = 0, len = page.items.length; i < len; i++) {
            let item = page.items[i];
            for (var key in item){
                let value = item[key];
                if(metadata.hasOwnProperty(key)){
                    item[key+"_parsed"] = metadata[key][value].value;
                }
                if(key == "pickupDate" || key == "dropoffDate"){
                    //Asociar valores del array metadata con la respuesta para agregar los valores.
                    item[key+"_parsed"] = {
                        val: item[key].split(" ", 2),
                    };

                    //Mostrar HOY - MAÑANA - FECHA en el card según corresponda
                    let dateService = new DateService();
                    let date = dateService.formatStringWithChar(item[key+"_parsed"].val[0]);
                    item[key+"_parsed"].dateTime = date;

                    if(date.setHours(0,0,0,0) == currentDate){
                        item[key+"_parsed"].date = "bookingList.CARD.today";
                    }else if (tomorrow == date.setHours(0,0,0,0)){
                        item[key+"_parsed"].date = "bookingList.CARD.tomorrow";
                    }else{
                        item[key+"_parsed"].date = item[key+"_parsed"].val[0];
                    }
                    item[key+"_parsed"].hour = item[key+"_parsed"].val[1];
                }

                if(key == "totalToBeCollectedBySupplier"){
                    item["totalToBeCollectedBySupplier_parsed"] = (item[key].toString()).replace('.',',');
                }
            }
            item.colorBooking = bookingColors[item.status];
            item.paymentDescription = 'bookingList.CARD.paymentDescription.' + item.paymentMethod;
            item.paymentTypeDescription = 'bookingList.CARD.paymentTypeDescription.' + item.paymentMethod;

        };

        return page;
    }

    exportData(){

        let columns = ["companyOid","companyName", "countryName", "fenixOid","status","reading","carName","totalDays","pickupDate","pickupCity","dropOffDate","dropOffCity","username","email","paymentMethod","totalPrice","carBrand",
            "carModel","searchCountryName","currencyCode","basePrice","commissionPercentage","totalTaxes","totalFees","bookedInsurancesTotalAmount",
            "insurancesCommission","bookedAssuredAdditionalsTotalAmount","bookedAssuredAdditionalsCommission","bookedNotAssuredAdditionalsTotalAmount","totalCommissionAmount"];

        let filters = this.getSelectedFilters(this.filterApplied);

        let url = `/cars-sara-v2/rest/company/${!this.companyOid?'all':(this.companyOid)}/booking/downloadExcel?language=${this.translator.currentLang}&${filters}&columns=${columns.join(',')}`;
        this.ga.notify("Autos_listado_de_reservas","Descargar", ["XLS"]);
        window.open(url);
    }

    private getSelectedFilters(filterApplied: any) {
        let filters = Object.keys(filterApplied).map(key => { return key + '=' + filterApplied[key]}).join('&');
        return filters;
    }


    changePageCallback(event){
        this.spage = event.page;
        window.scrollTo(0, 0);
        this.filterBookingList(this.filterApplied, true, false, false);
    }

    showFiltersMobile(event){
        this.openedFilters = true;
        this.dspFilters.show();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/booking.component.ts